const refundsConstants = {
	SET_REFUNDS_DATA: 'SET_REFUNDS_DATA',
};
export default refundsConstants;
